//
//
//
//
//
//
//
//
//
//
//
//
//
//

// jw: we need to parse any leading emojis
const emojiRegex = /([\uD800-\uDBFF][\uDC00-\uDFFF])/;

export default {
  name: 'ProductsFoundersCardItemBody',
  props: {
    value: {
      type: String,
      required: true,
    },
    highlighted: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    let title = this.value;

    const match = emojiRegex.exec(title);

    let icon = null;
    if (match?.index === 0) {
      [icon] = match;
      title = title.slice(icon.length).trim();
    }

    return { icon, title };
  },
};
